import { REF_SIZE_PT, SIZE_OPTIONS } from '../../../../../constants/size';
import { FONTS } from '../../../../../constants/fonts';

export const getMajorTitleMetrics = (orientation) => {
    const widthEM = 8.5;

    if (orientation === SIZE_OPTIONS.LANDSCAPE) {
        return {
            isUpperCase: true,
            fontFamily: FONTS.REGULAR,
            fontSize: 100,
            lineHeight: 120 / 100,
            width: widthEM * 100
        };
    }

    return {
        isUpperCase: true,
        fontFamily: FONTS.REGULAR,
        fontSize: 90,
        lineHeight: 120 / 90,
        width: widthEM * 100
    };
};

export const getTitleMetrics = (orientation) => {
    const widthEM = 8.5;

    if (orientation === SIZE_OPTIONS.LANDSCAPE) {
        return {
            isUpperCase: true,
            fontFamily: FONTS.REGULAR,
            fontSize: 70,
            lineHeight: 120 / 100,
            width: widthEM * 70
        };
    }

    return {
        isUpperCase: true,
        fontFamily: FONTS.REGULAR,
        fontSize: 90,
        lineHeight: 120 / 90,
        width: widthEM * 100
    };
};

export const getSubMetrics = (orientation, widthEM = 8) => {
    if (orientation === SIZE_OPTIONS.LANDSCAPE) {
        return {
            fontFamily: FONTS.ITALIC,
            fontSize: 24,
            lineHeight: 27 / 24,
            width: widthEM * 24 // em
        };
    }

    return {
        fontFamily: FONTS.ITALIC,
        fontSize: 38,
        lineHeight: 27 / 24,
        width: Math.min(widthEM * 38, REF_SIZE_PT.w * 0.73)
    };
};
